// extracted by mini-css-extract-plugin
export default {"taskTable":"TaskCompletion_taskTable__Vq5Ff","bubble":"TaskCompletion_bubble__Jq5MV","userCol":"TaskCompletion_userCol__J0ybH","footMonth":"TaskCompletion_footMonth__JBahU"};